<template>

  <div>
    <h4>Productos Ingresados</h4>
    <p>La plataforma ha detectado que los siguientes productos han ingresado a esta tienda. Revisa que el stock físico concuerde con el stock informado en este listado.</p>
    <Loader v-if="loading"></Loader>
    <b-list-group v-else>
      <b-list-group-item list-group-item-action class="pointer" v-for="list in productDetail.data" :key="list.product_map_id">
        <b-card>
          Información producto proveedor
          <h6>{{list.vendor_product_description}}</h6>
          <h6>{{list.vendor_product_code}}</h6>
          Información producto cadena
          <h6>{{list.retail_product_description}}</h6>
          <h6>{{list.retail_product_code}}</h6>
        </b-card>
        <b-card class="text-center">
          <b-row>
            <b-col>
              Stock Ingresado
              <h1>{{list.delta | number}}</h1>
            </b-col>
            <!--<b-col cols="6">-->
              <!--Stock en Unidades-->
              <!--<h6>{{list.stock_quantity | number}}</h6>-->
            <!--</b-col>-->
          </b-row>
          <!--<b-row class="mt-2">-->
            <!--<b-col cols="6">-->
              <!--Venta en $-->
              <!--<h6>{{list.real_sales_amount | money}}</h6>-->
            <!--</b-col>-->
            <!--<b-col cols="6">-->
              <!--Stock en $ (PVP)-->
              <!--<h6>{{list.real_stock_pvp_amount | money}}</h6>-->
            <!--</b-col>-->
          <!--</b-row>-->
        </b-card>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>


<script>
  import { newStockParameters } from '../../expertoRetail/defaultPayloads/organismsMobile'
  import { sales } from '../../services/api/ExpertoRetail'
  import Loader from '@/expertoRetail/atoms/ExpertoRetailLoader'

  export default {
    name: 'new-stock-product-list',
    components: {
      Loader
    },
    data () {
      return {
        productDetail: {
          data: {}
        },
        store_id: this.$store.state.mobile.store_id,
        loading: false
      }
    },
    created () {
      this.addFilter(this.store_id)
    },
    methods: {
      Request (parameters) {
        this.loading = true
        return new Promise((resolve, reject) => {
          let vm = this
          sales.salesTwoRanges(parameters)
            .then(response => {
              vm.productDetail.data = response.data
              resolve()
            })
            .catch(error => {
              reject(error)
            })
            .finally(() => {
              vm.loading = false
            })
        })
      },
      addFilter (id) {
        newStockParameters.parameters.store_filters.store_id = []
        newStockParameters.parameters.store_filters.store_id.push(id.toString())
        this.Request(newStockParameters)
      }
    }
  }
</script>


<style scoped>
  .bk-color {
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#1e5799+0,25146d+0,3f137c+73,50327a+98 */
    background: #0d1052; /* Old browsers */
  }
  .transparent {
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/expertoRetail/atoms/ExpertoRetailMobileNewStockProductList.vue